var elementSliderOptions= {
    "default": {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
    }
}

function openModalElement(id){
    let modal = $('#single-'+id)

    modal.modal("show")

    modal.on('shown.bs.modal', function () {
        var slider = $(this).find(".js-detailElement-slider")
        elementSliderOptions["default"].appendDots = $(this).find('.modal-header')

        if (slider.find('.js-detailElement-itemSlider').length > 1 && !slider.hasClass('slick-initialized')) {
            slider.slick(elementSliderOptions["default"]);
        } else {
            slider.slick('setPosition');
        }

        slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $(this).find(".js-detailElement-itemSlider").removeClass("d-none");
        });
    });
}

var productSliderOptionsModal= {
    "default": {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        appendDots: $('#productModal').find('.modal-header'),
    }
}

$('#productModal').on('shown.bs.modal', function () {
    var slider = $(".js-productModal-slider");

    slider.each(function () {
        // Inizializziamo lo slider solo se non è già stato inizializzato
        setTimeout(function() {
            if (slider.find('.js-productModal-itemSlider').length > 1 && !slider.hasClass('slick-initialized')) {
                // Inizializza lo slider
                slider.slick(productSliderOptionsModal["default"]);
            } else {
                // Se è già inizializzato, aggiorna la posizione
                slider.slick('setPosition');
            }
        }, 10);

    });
});

function openProductModal(index){
    var slider = $(".js-productModal-slider");

    // Garantiamo che la chiamata a slickGoTo avvenga solo dopo che lo slider è inizializzato
    function tryToGoToSlide() {
        if (slider.hasClass('slick-initialized')) {
            slider.slick('slickGoTo', index)
        } else {
            setTimeout(tryToGoToSlide, 10);  // Riprova
        }
    }

    setTimeout(tryToGoToSlide, 10);

    slider.on('afterChange', function(event, slick, currentSlide){
        if (currentSlide === index) {
            $('#productModal').find(".js-productModal-itemSlider").removeClass("d-none");
            $(this).off('afterChange');
        }
    });


    $('#productModal').modal('show')

}

function goToSingle() {
    let element = document.querySelector(".multipleItemSingle")
    element.scrollIntoView({behavior: "smooth"})
}

let killer = null
function initGsapScroll() {
    if(window.innerWidth>=992){
        gsap.registerPlugin(ScrollTrigger);

        const slider = $(".js-document-slider");
        const generalTexts = $(".js-document-itemSlider .generalText");

        // Inizialmente mostra solo il primo generalText
        generalTexts.hide();
        $(generalTexts[0]).show();

        const numOfTexts = generalTexts.length;

        let currentIndex = 0;
        let lastProgress = 0
        let lastProgressLogged = 0

        // Funzione per aggiornare il testo visibile
        const updateTextVisibility = () => {
            if(currentIndex < generalTexts.length){
                generalTexts.each(function(i) {
                    if (i === currentIndex) {
                        gsap.to($(this), { opacity: 1, duration: 0.5 });
                        $(generalTexts[currentIndex]).show()
                    } else {
                        gsap.to($(this), { opacity: 0, duration: 0.5 });
                        $(generalTexts[i]).hide()
                    }
                });
            }
        };

        // Imposta ScrollTrigger per lo slider
        killer = ScrollTrigger.create({
            trigger: slider[0],
            pin: true,
            start: "top top",
            end: `+=${slider.height() * 2}`, // area di scroll
            scrub: 1,
            markers: false,
            onUpdate: (self) => {
                const scrollPosition = self.scroll();

                // Calcola la frazione della progressione corrente
                const progressFraction = Math.floor(self.progress * numOfTexts);

                if (self.progress > lastProgress) {
                    // scroll verso il basso
                    if (progressFraction > lastProgressLogged) {
                        currentIndex++;
                        updateTextVisibility();
                        lastProgressLogged = progressFraction;
                    }
                } else if (self.progress < lastProgress) {
                    // scroll verso l'alto
                    if (progressFraction < lastProgressLogged) {
                        currentIndex--;
                        updateTextVisibility();
                        lastProgressLogged = progressFraction;
                    }
                }

                lastProgress = self.progress
            }
        });

        // Animazione di animazione per l'entrata di ogni generalText
        generalTexts.each(function(i) {
            gsap.fromTo($(this), { opacity: 0 }, { opacity: 1, duration: 1, delay: i * 0.2 });
        });
    }

}

var productSliderOptions= {
    "default": {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        variableWidth: true
    }
}

var shrSliderOptions= {
    "default": {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        centerMode: true,
        arrows: false,
        variableWidth: true
    }
}

var productSlider = $(".js-product-slider")
function initProductSlider() {
    productSlider.each(function () {
        if(productSlider.find('.js-product-itemSlider').length>1 && !productSlider.hasClass('slick-initialized') && window.innerWidth < 992){
            productSlider.slick(productSliderOptions["default"])
        }
    })
}

var shrSlider = $(".js-shr-slider")
function initShrSlider() {
    shrSlider.each(function () {
        if($(this).find('.js-shr-itemSlider').length>1 && !$(this).hasClass('slick-initialized') && window.innerWidth < 992){
            $(this).slick(shrSliderOptions["default"])
        }
    })
}

function handleResize() {
    if (window.innerWidth >= 992) {

        if (productSlider.hasClass('slick-initialized')) {
            productSlider.slick("unslick")
        }

        if (shrSlider.hasClass('slick-initialized')) {
            shrSlider.slick("unslick");
        }

        if (!killer) {
            initGsapScroll();
        }
    } else {

        initShrSlider()
        initProductSlider()

        if (killer) {
            killer.kill();
            killer = null;
            $(".js-document-itemSlider .generalText").removeAttr("style")
        }
    }
}

$(window).on('resize', handleResize);

$(document).ready(function () {

    handleResize()

    let productVideo = $("#productVideo")
    let locale = $("#locale").text()


    const isDesktop = window.innerWidth >= 1200;
    const isVertical = screen.availHeight > screen.availWidth;

    let videoUrl;

    if (isDesktop || !isVertical) {
        videoUrl = locale === "it-IT" ? "https://assets.4flow.cloud/Professional_Pura_Teaser_Video_1920x960_IT.mp4?pEFs=cVY2M1MyN1ZOMFFadEQ5ZlVOMzhVNTd1SkJMZFdaYmFoem1HRU1Dektjckx4eGFwK0s0QTFXZUI2cDVSRHBJeEVKajd0d3FLTHJ1c2pXQ3EzRWJVdTgvdEM4T3Fqb0Z3dzhLeURpMWhKaHlnNDNkcDd5Z21OZ2F4MEllWitmeDgvMm05VXhFcDdJWW9sODZtSzJOZWlFQ3pDRWZFMmN4UHBkU0dFbTNCVlc3bjEzeGdXYi9IZ01DLzRpdS9OR3lZ" :
            (locale === "pl-PL" ? "https://assets.4flow.cloud/Professional_Pura_Teaser_Video_PL_1920x960.mp4?pEFs=cVY2M1MyN1ZOMFFadEQ5ZlVOMzhVN3o0TWpMT2ZlcXRtT0ZwazV1SXZRWmVGOHo2YXp2M0tkQ25hZHhIVEM4c1FsZ0IzYWx0bWZTY1UrOGhmb0ZScWxuclR3WjFpL25TeHJSNkIzYzc5UlM3MmtpeGlya3hoY3FqUDVBM0dFRVIyWkUzTm93Smw5cUJWczVlUTg1THJ5czdzYUpkUHNLcjFDRlN1WDZVL25zRGdmeERIQVRkdFRSSE9ZbFZnbFJR" :
                (locale === "ru-RU" ? "https://assets.4flow.cloud/Professional_Pura_Teaser_Video_1920x960_RU.mp4?pEFs=cVY2M1MyN1ZOMFFadEQ5ZlVOMzhVMEpyN2tvSGtEWUpwWnVYaDJnOWFMVzAwTUk3ZUVZeS9EditlZHNRUWkranRFWnlEZ1NkMWpwVUNkQkNPaHpXTGVLdGppQ3JSTEQ0dlRJeHhRUHdKeXJRdExRSXBianhXaEtjTHpzZlJETlRhdm9vcy8zMGZyOHY4MHNQdFVjWmxRbU96VUNaMGdGWHFVdnJKclZQbHplSmhjcFYzUzJPUHZZWVpGQjRsbjlV" :
                    "https://assets.4flow.cloud/Professional_Pura_Teaser_Video_ENG.mp4?pEFs=cVY2M1MyN1ZOMFFadEQ5ZlVOMzhVOVJPV1NPV3dwS1Y1bkFSNmZpTUlLYkJaK3diakVqN0JLa2JneU9lTFRNWDVjZEJBZko2TWVkMFhyY1c3a2FwQUFSenJQVTVMN29WNUdWQTJyaHg0akxta2ZZZ2JKQkFodzZaN0JzMmpTYi80YmNYMWRUdTNLRlZkQXMydmNvcUsvODB2ajEvRUVQeFZPWGtPTjJRV1RDNStLZDVNK3o1Y3pPTmxZVzdEenow"));
    } else {
        videoUrl = locale === "it-IT" ? "https://assets.4flow.cloud/Professional_Pura_Teaser_Video_Vertical_IT.mp4?pEFs=cVY2M1MyN1ZOMFFadEQ5ZlVOMzhVM3NVR1ZTQjBEeHR0cVpjc3dMdENvOHVwVDVpZEMybGdkdTBwaGdNcTZ4Y09oUisyMWFFWjZTYlQvbUZGd2FWVkZoYmdtcmdGTWFLcDJSS2ozVG1KWWNkbnlxalg4ckVWSFhhcEVHYU1jaXpmU004ZEJjdTV3WnAxaUFGemhZeEF1bFB4YTZFa3NIeVF6NWM1MmVveDFmQUkxWEpJN0I4T2NyRVhPbVY1TGlM " :
            (locale === "pl-PL" ? "https://assets.4flow.cloud/Professional_Pura_Teaser_Video_PL_620x886.mp4?pEFs=cVY2M1MyN1ZOMFFadEQ5ZlVOMzhVNUphTDdyWnRxWk5ON1BCQkx3cWlBSEhIUklBQmRieFYwMGlWcGtsdzQ0UW0xak5lN0V6MGNKdWpEbFpLcEJENXBrWnBTUWRTUWtheUptR1FmeDVad3Z6cGpiclVKNUFQaktodzBPMmk4TVVnTFZVZzViTFphUFhXOWswdEdPN2c2RFFoUytmU0k0Tkhub28rZ0RRRS9rYXRGSDhsUlFEV0RVakd0bWhyK0s4" :
                (locale === "ru-RU" ? "https://assets.4flow.cloud/Professional_Pura_Teaser_Video_Vertical_RU.mp4?pEFs=cVY2M1MyN1ZOMFFadEQ5ZlVOMzhVOWtHZDlweE9QZFpOREc3YmtXMjFXWXVHTjJ0b1loMjBybjhVdVVSNE5ySHQ4ckFlYW9Va0VGSHJ0MlpyeXdmaXRycWphTkVVRnk3d2twaXNBaVAxZy9hdlZ2VmF4b3hMU3NybjRBaEwzbnFaSm5OVEpkVldJbUI3R296dnArYmJiYzdDSCtwb1pCU1BuT1lkaE1kV1ZOVFNxblZRSkkyVm4ydVVNd1EvREli" :
                    "https://assets.4flow.cloud/Professional_Pura_Teaser_Video_ENG_620x886.mp4?pEFs=cVY2M1MyN1ZOMFFadEQ5ZlVOMzhVMG5ZZlg3YmIrT01iWmsweWJ1OHFnT1RLbFZzdmxnK2wxYlR1SE1nZGNIdTRDRzVmWW9GWHNtSmdVdm50TkNuQkgvVVkzOUFLNWxOTEc1YlY4bVFhQ2Nyay9XMWRHMk5MbGw2aGNuQlJ1TjhPVndNME45RWFxUElsMlQ1OGJucUlhUFVxNm5BTkhxa3l6aitBK1orVVlDTGpHMEU2bjFjRjErWHJYVDQ4VFhn"));
    }

    productVideo.prop("src", videoUrl);
    productVideo.get(0).play()

    var video = $('#filterVideo');

    video.hover(function() {
        video[0].loop = true;
        video[0].play();
    }, function() {
        video[0].pause();
        video[0].currentTime = 0;
    });

    $('.openDrawer').off('click').on('click', function() {
        var h = window.innerWidth>=768 ? 330 : 120;
        var hiddenContent = $('.hiddenContent');

        if (hiddenContent.hasClass('show')) {
            hiddenContent.removeClass('show');
            hiddenContent.css('display', 'none');
            $('#opening-drawer').animate({height:-88}, 1200)
        } else {
            $('#opening-drawer').animate({height:h}, 1200, () => {
                hiddenContent.css('display', 'flex');
                hiddenContent.addClass('show');
            })
        }
    });

    $('[data-toggle="popover"]').popover({html: true})

    var scrollCardSliderOptions= {
        "default": {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        variableWidth: false,
                        centerMode: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        variableWidth: true,
                    }
                }
            ]
        }
    }

    var scrollCardSlider = $(".js-scrollCard-slider")
    scrollCardSlider.each(function () {
        if(scrollCardSlider.find('.js-scrollCard-itemSlider').length>1 && !scrollCardSlider.hasClass('slick-initialized')){
            scrollCardSlider.slick(scrollCardSliderOptions["default"])
        }
    })

})